import { render, staticRenderFns } from "./ImportPerformantTrot.vue?vue&type=template&id=0a0f5e11&"
import script from "./ImportPerformantTrot.vue?vue&type=script&lang=js&"
export * from "./ImportPerformantTrot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports